// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1QXUW","inner":"Footer_inner__3z9hd","nextIcon":"Footer_nextIcon__1bMvO","innerLeft":"Footer_innerLeft__3qT-C"};